import { fabric } from "fabric";
import cloneDeep from "lodash/cloneDeep";
import { canvas } from "@/canvas-api/Canvas";

// prettier-ignore
const addObjectsToMain = (canvasObjects: fabric.Object[], mainLabel: fabric.Group) => {
	for (const obj of canvasObjects) {
		if (
			obj.name &&
			(
        obj.name === "svgShape" ||
				obj.name === "clipArt"  ||
				obj.name === "iText"    ||
				obj.name === "image"    ||
        obj.name === "group"
      )
		) {
			mainLabel.addWithUpdate(obj);
		}
	}
};

const clonePart = (part: fabric.Object): Promise<fabric.Object> => {
  return new Promise((resolve) => {
    part.clone(
      function(clone: fabric.Object) {
        resolve(clone);
      },
      ["name", "type"]
    );
  });
};

export default async (): Promise<fabric.Group | undefined> => {
  const canvasObjects: fabric.Object[] = cloneDeep(canvas.value.getObjects() as fabric.Object[]);

  const mainLabel = new fabric.Group(undefined, {
    name: "mainLabel",
    originX: "center",
    originY: "center",
    evented: false,
    selectable: false,
  });

  const withBleed = canvasObjects.find((obj) => obj.name === "labelCanvas"); // This is the main canvas, it is bleedWith and bleedHeight
  const labelSize = canvasObjects.find((obj) => obj.name === "actualLabelSize");

  if (withBleed && labelSize) {
    try {
      const values = await Promise.all([clonePart(withBleed), clonePart(labelSize)]);

      const cloneWithBleed = values[0];
      const cloneLabelSize = values[1];

      mainLabel.addWithUpdate(cloneWithBleed);
      mainLabel.addWithUpdate(cloneLabelSize);

      addObjectsToMain(canvasObjects, mainLabel);

      return mainLabel;
    } catch (e) {
      console.log(e);
    }
  }
};
